<div *ngIf="trainingId !== null && quizForm" style="width: 100%;">
  <form [formGroup]="quizForm" style="width: 100%;">
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step *ngFor="let step of quiz.quizData.steps; let i = index">
        <div *ngFor="let item of step.items;let q = index" class="item" style="margin-top: 10px">
          <div style="display: flex; flex-direction: row;">
            <div style="flex:1 1 calc(100%)" class="question">
              <ng-container *ngIf="item.type == 'image'">
                <img *ngIf="item.src"
                     [src]="api + '/api/trainings/file?name=' + encodeURIComponent(item.src) + '&path=Account/Trainings' + '&token=' + userToken"
                     style="max-width: 100%;"/>
              </ng-container>
              <ng-container *ngIf="item.type == 'question'">
                <div style="display: flex; flex-direction: row; font-weight: bold;font-size: 1.2em;margin-bottom:10px;">
                  {{q + 1}}) {{item.name}}
                </div>
                <div style="margin-left: 10px;" *ngIf="!item.multiple">

                  <mat-radio-group [name]="'r' + i + '_' + q" [formControlName]="'r' + i + '_' + q">
                    <div *ngFor="let a of item.answers;let h = index" style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 auto">
                        <mat-radio-button [value]="h">{{'ABCDEFGHIJKL'[h]}}. {{a.name}}</mat-radio-button>
                      </div>
                    </div>
                  </mat-radio-group>
                </div>
                <div style="margin-left: 10px;" *ngIf="item.multiple">
                  <div *ngFor="let a of item.answers;let h = index" style="display: flex; flex-direction: row;">
                    <div style="flex:0 0 50px">
                      <mat-checkbox [name]="'r' + i + '_' + q + '_' + h"
                                    [formControlName]="'r' + i + '_' + q + '_' + h">{{'ABCDEFGHIJKL'[h]}}
                        . {{a.name}}</mat-checkbox>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="item.type == 'video'">
                <youtube-player [videoId]="item.src?.split('=').pop()" disablePlaceholder [height]="300"></youtube-player>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="i == (quiz.quizData.steps.length - 1)">
          <div style="font-weight: bold">I acknowledge that I have completed this IT security training quiz on
            my
            own.
          </div>
          <div style="display: flex; flex-direction: row; gap: 10px">
            <div>
              <mat-form-field>
                <mat-label>Name</mat-label><input matInput name="name" formControlName="name"  required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Date</mat-label><input matInput name="date" formControlName="date" [matDatepicker]="picker1"
                                      required>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="controls">
          <button mat-raised-button *ngIf="i > 0"
                  matStepperPrevious
                  type="button">
            Previous
          </button>
          <button mat-raised-button *ngIf="i < (quiz.quizData.steps.length - 1)"
                  matStepperNext
                  type="button">
            Next
          </button>
          <button mat-raised-button (click)="send()" *ngIf="i == (quiz.quizData.steps.length - 1)">Send</button>
        </div>

      </mat-step>
    </mat-horizontal-stepper>
  </form>


  <div *ngIf="trainingId === null" class="training-link">
    Please, select training
  </div>
</div>
